/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hearaboutoffer2Inputs */

const en__field_hearaboutoffer2 = /** @type {(inputs: _Field_Hearaboutoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How did you hear about our offers?`)
};

const de__field_hearaboutoffer2 = /** @type {(inputs: _Field_Hearaboutoffer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie haben Sie von unserem Angebot erfahren?`)
};

/**
* | output |
* | --- |
* | "How did you hear about our offers?" |
*
* @param {_Field_Hearaboutoffer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hearaboutoffer2 = /** @type {((inputs?: _Field_Hearaboutoffer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hearaboutoffer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hearaboutoffer2(inputs)
	return de__field_hearaboutoffer2(inputs)
});
export { _field_hearaboutoffer2 as "_field_hearAboutOffer" }